'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 扩展变化活动，增加或者删除，插件启动时增加扩展、停止时删除扩展
 * 
 * @export
 * @class ExtensionAction
 */
var ExtensionAction =

/**
 * 创建一个扩展变更活动
 * 
 * @ignore
 * @param {any} action 
 * @memberof ExtensionAction
 */

/**
 * 增加扩展
 * 
 * @static
 * @memberof ExtensionAction
 */
function ExtensionAction(action) {
  (0, _classCallCheck3.default)(this, ExtensionAction);

  this.action = action;
  (0, _freeze2.default)(this);
}

/**
 * 变化的活动集合，增加、删除
 * 
 * @static
 * @memberof ExtensionAction
 */

/**
 * 删除扩展
 * 
 * @static
 * @memberof ExtensionAction
 */
;

ExtensionAction.ADDED = new ExtensionAction('added');
ExtensionAction.REMOVED = new ExtensionAction('removed');

ExtensionAction.values = function () {
  var enumValues = [];
  enumValues.push(ExtensionAction.ADDED);
  enumValues.push(ExtensionAction.REMOVED);
  return enumValues;
};

exports.default = ExtensionAction;


(0, _freeze2.default)(ExtensionAction);
//# sourceMappingURL=ExtensionAction.js.map